import get from 'lodash/get';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';

import App from 'presentation/App';
import 'global.css';
import checkCustomerUrlUpdated from 'actions/session/checkCustomerUrlUpdated';

const URL_TRACKING_INTERVAL = 5000;

export default function({ store }) {
  window.setInterval(() => {
    store.dispatch(checkCustomerUrlUpdated);
  }, URL_TRACKING_INTERVAL);

  const gladlyDiv = document.createElement('div');
  gladlyDiv.setAttribute('id', 'gladlyChat_container');
  gladlyDiv.setAttribute('class', 'cleanslate');
  const body = document.getElementsByTagName('body')[0];
  body.appendChild(gladlyDiv);

  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    gladlyDiv
  );

  providerChangeListener(store);
}

const providerChangeListener = function(store) {
  let currentProvider = getProvider(store.getState());
  let unsubscribe = store.subscribe(() => {
    let previousProvider = currentProvider;
    currentProvider = getProvider(store.getState());
    if (currentProvider != previousProvider) {
      ReactDOM.unmountComponentAtNode(document.getElementById('gladlyChat_container'));
      unsubscribe();
    }
  });
};

const getConfiguration = function(state) {
  return get(state, 'configuration.config');
};

const getProvider = function(state) {
  return get(getConfiguration(state), 'provider');
};
